import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../lib/api";

export default function EmployerHome() {
  const navigate = useNavigate();
  useEffect(() => {
    API.get("/employer/organization")
      .then(({ data }) => navigate(data.status === "verified" ? "/employer/search" : "/employer/organization", { replace: true }))
      .catch(() => navigate("/employer/organization", { replace: true }));
  }, [navigate]);
  return <div className="flex min-h-screen items-center justify-center bg-[#FDFBF7]"><div className="h-8 w-8 animate-spin rounded-full border-2 border-[#1F4A38] border-t-transparent" /></div>;
}
